import { SlideUpModal } from "src/components/SlideUpModal";
import { useWebClientApi } from "src/api";
import { useDlaFormSubmit } from "src/hooks/useDlaFormSubmit";

export type RemoveCoborrowerModalProps = {
  isOpen: boolean;
  coborrowerName: string;
  coborrower_id: string;
  closeHandler: () => void;
  confirmHandler: () => void;
};

export default ({
  isOpen,
  coborrowerName,
  coborrower_id,
  closeHandler,
  confirmHandler,
}: RemoveCoborrowerModalProps) => {
  const api = useWebClientApi();
  const [submitHandler, loading] = useDlaFormSubmit(
    () => api.deleteBorrower(coborrower_id),
    { onSuccess: confirmHandler },
  );

  return (
    <SlideUpModal
      title={`Are you sure you want to remove ${coborrowerName} to your application?`}
      isOpen={isOpen}
      closeHandler={closeHandler}
      hasDismissButton={true}
      actionButtonText="Remove"
      actionButtonClickHandler={() => void submitHandler({})}
      isLoading={loading}
      variant="danger"
    />
  );
};
